export type SellerOrdersParams = {
  page: number;
  limit: number;
  status?: string;
  search?: string;
};

export type SellerPaymentsParams = {
  page: number;
  limit: number;
  search?: string;
  dateFrom?: string;
  dateTo?: string;
};

export type SellerProductsParams = {
  page: number;
  limit: number;
  search?: string;
  isActive?: string;
  category?: string;
};

export type SellerOffersParams = {
  page: number;
  limit: number;
  status?: string;
};

export const sellerKeys = {
  all: ['seller'] as const,
  stats: () => [...sellerKeys.all, 'stats'] as const,
  orders: (params: SellerOrdersParams) => [...sellerKeys.all, 'orders', params] as const,
  ordersPrefix: () => [...sellerKeys.all, 'orders'] as const,
  payments: (params: SellerPaymentsParams) => [...sellerKeys.all, 'payments', params] as const,
  paymentsPrefix: () => [...sellerKeys.all, 'payments'] as const,
  products: (params: SellerProductsParams) => [...sellerKeys.all, 'products', params] as const,
  productsPrefix: () => [...sellerKeys.all, 'products'] as const,
  offers: (params: SellerOffersParams) => [...sellerKeys.all, 'offers', params] as const,
  offersPrefix: () => [...sellerKeys.all, 'offers'] as const,
  conversations: () => [...sellerKeys.all, 'conversations'] as const,
  conversationMessages: (conversationId: string) =>
    [...sellerKeys.all, 'conversationMessages', conversationId] as const,
  pendingOfferCount: () => [...sellerKeys.all, 'pendingOfferCount'] as const,
  orderApproval: () => [...sellerKeys.all, 'orderApproval'] as const,
};
